import { NgModule } from '@angular/core';

import { SharedModule } from '@app/shared';
import { PolicyEngineMenuComponent } from './policy-engine-menu.component';

@NgModule({
    imports: [SharedModule],
    declarations: [PolicyEngineMenuComponent],
    entryComponents: [PolicyEngineMenuComponent],
    exports: [PolicyEngineMenuComponent]
})
export class PolicyEngineMenuModule {
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/authorized/policyEngine/policy-engine-menu/policy-engine-menu.module.ts